module.exports = __webpack_public_path__ + "static/media/josip-hover.14d11493.png";